<template>
  <nav class="mt-8 flex h-14 flex-row items-center gap-1 border-b border-black-10 bg-white px-4 tablet:px-6 overflow-x-auto">
    <NuxtLink
      class="flex h-10 flex-shrink-0 flex-row items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-200 tablet:px-4"
      :class="isActive('/admin/users') ? 'bg-black-03 text-black-100' : 'text-black-70 hover:bg-black-03'"
      :to="localePath('/admin/users')"
    >
      <UIIcon name="id" />
      <span class="whitespace-nowrap">Users</span>
    </NuxtLink>
    <NuxtLink
      class="flex h-10 flex-shrink-0 flex-row items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-200 tablet:px-4"
      :class="isActive('/admin/services') ? 'bg-black-03 text-black-100' : 'text-black-70 hover:bg-black-03'"
      :to="localePath('/admin/services')"
    >
      <UIIcon name="services" />
      <span class="whitespace-nowrap">Services</span>
    </NuxtLink>
    <NuxtLink
      class="flex h-10 flex-shrink-0 flex-row items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-200 tablet:px-4"
      :class="isActive('/admin/training') ? 'bg-black-03 text-black-100' : 'text-black-70 hover:bg-black-03'"
      :to="localePath('/admin/training')"
    >
      <UIIcon name="training" />
      <span class="whitespace-nowrap">{{ $t('admin.sidebar.training') }}</span>
    </NuxtLink>
    <NuxtLink
      class="flex h-10 flex-shrink-0 flex-row items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-200 tablet:px-4"
      :class="isActive('/admin/portfolio') ? 'bg-black-03 text-black-100' : 'text-black-70 hover:bg-black-03'"
      :to="localePath('/admin/portfolio')"
    >
      <UIIcon name="portfolio" />
      <span class="whitespace-nowrap">Portfolio</span>
    </NuxtLink>
    <NuxtLink
      class="flex h-10 flex-shrink-0 flex-row items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-200 tablet:px-4"
      :class="isActive('/admin/packages') ? 'bg-black-03 text-black-100' : 'text-black-70 hover:bg-black-03'"
      :to="localePath('/admin/packages')"
    >
      <UIIcon name="crown" />
      <span class="whitespace-nowrap">Packages</span>
    </NuxtLink>
    <NuxtLink
      class="flex h-10 flex-shrink-0 flex-row items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-200 tablet:px-4"
      :class="isActive('/admin/points-of-interest') ? 'bg-black-03 text-black-100' : 'text-black-70 hover:bg-black-03'"
      :to="localePath('/admin/points-of-interest')"
    >
      <UIIcon name="location" />
      <span class="whitespace-nowrap">Points of Interest</span>
    </NuxtLink>
  </nav>
</template>

<script setup lang="ts">
const route = useRoute()
const localePath = useLocalePath()

const isActive = (path: string) => {
  return route.path.startsWith(path)
}
</script>

<style scoped>
nav {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
  -webkit-overflow-scrolling: touch;
}

nav::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}
</style>

